export function init() {
    $('.block--featurelistingblock .block__inner--vertical').each(function () {
        const $this = $(this),
            $featureItems = $this.find('.feature__list__item'),
            $featureImages = $this.find('.block__img');

        $featureItems.click(function () {
            const $this = $(this);

            $featureImages.removeClass('block__img--active');
            $featureItems.removeClass('feature__list__item--active');
            $featureImages.eq($this.index()).addClass('block__img--active');
            $this.addClass('feature__list__item--active');
        });
    })
}